// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"06ebaf1f","634":"1909e893","680":"8ec391da","715":"f25fde0e","863":"de6e9d45"}[chunkId] + ".chunk.js";
};